import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="container py-5 mt-5 pt-4">
      <h1 className="mb-4">Privacy Policy</h1>

      <p>
        At <strong>Asia Academic Press</strong>, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your personal information when you visit our website or submit content for publication.
      </p>

      <h4>Information We Collect</h4>
      <ul>
        <li>Personal details such as name, email address, institution, and contact number when submitting a paper or contacting us.</li>
        <li>Technical data like IP address, browser type, and usage patterns via analytics tools.</li>
      </ul>

      <h4>How We Use Your Information</h4>
      <ul>
        <li>To process and manage paper submissions.</li>
        <li>To communicate with authors, reviewers, and editors.</li>
        <li>To improve our website and services.</li>
        <li>To comply with legal obligations.</li>
      </ul>

      <h4>Cookies</h4>
      <p>
        Our website may use cookies to enhance your browsing experience. You can disable cookies through your browser settings if you prefer.
      </p>

      <h4>Third-Party Services</h4>
      <p>
        We do not sell or share your personal data with third parties for marketing. We may use third-party services (e.g., analytics tools) that adhere to privacy and security best practices.
      </p>

      <h4>Data Security</h4>
      <p>
        We implement standard security measures to protect your information, but we cannot guarantee absolute security over the internet.
      </p>

      <h4>Your Rights</h4>
      <p>
        You have the right to request access to or deletion of your personal data. Contact us at <a href="mailto:info@asiaacademicpress.com">info@asiaacademicpress.com</a> for any data-related queries.
      </p>
    </div>
  );
}

export default PrivacyPolicy;
